<template>
  <router-link
    :class="$style.listItem"
    :to="{
      name: 'calendarSettingBooking',
      params: {
        bookingGUID: node.guid,
        entranceGUID: route.params.entranceGUID,
      },
    }"
  >
    <div :class="$style.listItem__date">
      <div>
        {{ dateStringForDisplay(node) }}
      </div>
    </div>
    <DolphinChip v-if="node.cancelReason" :class="$style.listItem__cancelChip">
      キャンセル済み
    </DolphinChip>
    <div :class="$style.listItem__summary">{{ node.summary }}</div>
    <div :class="$style.listItem__displayName">
      {{ node.assignedStaff.displayName }}
    </div>
  </router-link>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DolphinChip from '@/components/atoms/DolphinChip.vue'
import { dateStringForDisplay } from './booking.ts'
import type { BookingListElementBookingFragment } from './BookingListElement.generated.ts'

const route = useRoute('calendarSetting')

const props = defineProps<{
  booking: BookingListElementBookingFragment
}>()

const node = computed(() => props.booking)
</script>

<style lang="scss" module>
.listItem {
  padding: 16px;
  border: 1px solid $color-border-low-emphasis;
  border-radius: $border-radius-v2-base;

  &:hover {
    background-color: $color-surface-accent-primary-light;
  }

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  color: $color-text-and-object-high-emphasis;

  &__date {
    flex-shrink: 0;
  }

  &__cancelChip {
    flex-shrink: 0;
    color: $color-text-and-object-high-emphasis-inverse;
    background-color: $color-label-gray;
  }

  &__summary {
    flex-grow: 1;
  }

  &__displayName {
    flex-shrink: 0;
    max-width: 100px;
    overflow-wrap: anywhere;
  }
}

.loadMoreButton {
  margin-top: 16px;
}
</style>
